'use client';

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Cookies from 'js-cookie';
import { Button, Menu } from '@mantine/core';
import { IconLogout, IconLayoutDashboard } from '@tabler/icons-react';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';
import styles from './LogoutButton.module.scss';

const LogoutButton = () => {
  const dictionary = useDictionary();
  const [token, setToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    const t = Cookies.get('authToken');
    setToken(t);
  }, []);

  if (!token) {
    return (
      <Button className={styles.login} component={Link} href="/login">
        {dictionary.header.login}
      </Button>
    );
  }

  return (
    <Menu shadow="md" width={220} withArrow>
      <Menu.Target>
        <Button className={styles.logout}>
          {dictionary.header.dashboard}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          component={Link}
          href="/admin"
          leftSection={<IconLayoutDashboard size={16} />}
        >
          {dictionary.header.dashboard}
        </Menu.Item>
        <Menu.Item
          color="red"
          leftSection={<IconLogout size={16} />}
          onClick={() => {
            Cookies.remove('authToken');
            window.location.reload();
          }}
        >
          {dictionary.header.logout}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default LogoutButton;
